import { Box, Stack, Text } from '@ui'
import { useSpaceIdFromPathname } from 'hooks/useSpaceInfoFromPathname'
import { useUSDCApprove } from 'hooks/useUSDCApprove'
import { GetSigner, PrimaryWalletNotConnectedButton, WalletReady } from 'privy/WalletReady'
import { Button } from 'ui/components/Button/Button'
import { ButtonSpinner } from 'ui/components/Spinner/ButtonSpinner'
import { shortAddress } from 'ui/utils/utils'
import { SpaceAddressFromSpaceId, useMyUserId, usePrimaryWallet } from 'use-towns-client'

export function InsufficientEOAAllowance(props: { amount: bigint }) {
    const { amount } = props
    const {
        mutate: approve,
        isPending,
        error,
    } = useUSDCApprove({
        onError: (error) => {
            console.error('Approve transaction failed', error)
        },
    })
    const spaceId = useSpaceIdFromPathname()

    const handleApprove = async (getSigner: GetSigner) => {
        const signer = await getSigner()
        if (!signer || !spaceId) {
            console.error('Missing required data for approve transaction', {
                signer,
                spaceId,
            })
            return
        }
        const spaceAddress = SpaceAddressFromSpaceId(spaceId)
        approve({
            signer,
            spenderAddress: spaceAddress,
            amount: amount,
        })
    }

    return (
        <Box centerContent gap="md">
            <WalletReady withPrimaryWallet ConnectButton={<ConnectWalletButton />}>
                {({ getSigner }) => (
                    <Button
                        tone="cta1"
                        disabled={isPending}
                        rounded="md"
                        size="button_sm"
                        onClick={() => handleApprove(getSigner)}
                    >
                        Approve USDC
                        {isPending ? <ButtonSpinner /> : null}
                    </Button>
                )}
            </WalletReady>
            <Text size="sm" textAlign="center">
                {`To send a tip, you need to approve the space to spend your USDC.`}
            </Text>
            {error ? (
                <Text size="sm" color="negative">
                    There was an error approving the USDC. Please try again.
                </Text>
            ) : null}
        </Box>
    )
}

function ConnectWalletButton() {
    const userId = useMyUserId()
    const { data: primaryWallet } = usePrimaryWallet({ rootWallet: userId })

    return (
        <Stack centerContent gap="sm">
            <Text size="xs" color="gray2">
                Connect {shortAddress(primaryWallet?.address ?? '')} to send a tip.
            </Text>
            <PrimaryWalletNotConnectedButton
                buttonSize="button_sm"
                withTooltip={false}
                buttonRounded="md"
            />
        </Stack>
    )
}
